import { useSelector } from 'src/hooks/useSelector';
import { UserType } from 'src/models/userType';

export const useMainPageSignupEnable = (): boolean =>
    useSelector(
        ({ anonymousSignUp, userType }) =>
            UserType.Anonymous === userType && anonymousSignUp.type === 'mainPage' && !anonymousSignUp.alreadyShown
    );
